<style lang="scss" scoped>
    $padding: 15px;
    $width: 410px;
    .vc-cart {
        // Position
        position: absolute;
        top: 60px;
        right: 16px;
        z-index: 1000;

        // Box
        width: $width;

        &__container {
            // Box
            border-radius: 5px;
            background-color: var(--menu-panel-background-color);
            box-shadow: 0 1px 19px rgba(0, 0, 0, 0.18);
            padding-bottom: 0 $padding;

            // Text
            color: var(--menu-item-text-color);
        }

        &__popup-arrow {
            position: absolute;
            top: -19px;
            right: 4%;
            width: 20px;
            height: 20px;
            background-color: var(--menu-panel-background-color);
            -webkit-clip-path: polygon(50% 60%, 0% 100%, 100% 100%);
            clip-path: polygon(50% 60%, 0% 100%, 100% 100%);
        }

        &__empty {
            text-align: center;
            padding: $padding;
        }

        &__header {
            padding: $padding $padding ((10/15)*$padding) $padding;

            &__title {
                font-size: 20px;
                font-weight: 600;
                color: var(--menu-item-active-text-color);
                text-transform: uppercase;
            }
        }

        &__main {
            padding: 0 $padding $padding $padding;
            overflow-y: auto;
            overflow-x: hidden;
            max-height: 286px;

            /* Scrollbar */
            &::-webkit-scrollbar {
                width: 8px;
            }

            /* Track */
            &::-webkit-scrollbar-track {
                background: transparent;
            }

            /* Handle */
            &::-webkit-scrollbar-thumb, &::-webkit-scrollbar-thumb:hover {
                background: #a7a7a7;
                border-radius: 5px;
            }
        }

        &__footer {
            &__discount {
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: ((8 / 15)*$padding) $padding;
                color: var(--menu-item-text-color);
                background: var(--menu-item-active-text-color-faded);

                &__text {
                    display: flex;
                    font-size: 12px;
                }

                &__icon {
                    position: relative;
                    top: -2px;
                    margin-right: 8px;
                    fill: var(--menu-item-active-text-color) !important;
                    width: 11px;
                }

                &__button {
                    font-size: 12px;
                }
            }

            &__buttons {
                display: grid;
                padding: $padding;
                grid-template-columns: auto auto;
                grid-gap: 10px;
                // Overrides
                .c-button {
                    white-space: normal;
                }
            }
        }

        @media screen and (max-width: $width + 20px + 36px) {
            .vc-cart__container {
                position: fixed;
                left: 10px;
                right: 10px;
            }
        }
    }
</style>

<template>
    <div :class="{'vc-cart--empty': cart.isEmpty()}" @mouseenter="keepCartPopupActive(true)"
         @mouseleave="keepCartPopupActive(false)" class="vc-cart">
        <div class="vc-cart__popup-arrow"></div>
        <div class="vc-cart__container">
            <template v-if="cart.isEmpty()">
                <div class="vc-cart__empty"> Your Cart is Empty</div>
            </template>
            <template v-else>
                <cart-header :itemAdded="mobile" class="vc-cart__header"></cart-header>
                <div class="vc-cart__main">
                    <template v-if="!mobile">
                        <cart-items-list></cart-items-list>
                    </template>
                    <template v-else>
                        <cart-item :cartItem="lastItemInCart" @removeCartItem="cart.removeItem($event)"></cart-item>
                    </template>
                </div>
                <div class="vc-cart__footer">
                    <base-transition-expand>
                        <div class="vc-cart__footer__discount" v-if="showPackageDiscountsNotice">
                        <span class="vc-cart__footer__discount__text">
                            <base-discount-icon class="vc-cart__footer__discount__icon"></base-discount-icon>
                            Add more beats for discounts.
                        </span>
                            <button @click="showPackageDiscounts"
                                    class="vc-cart__footer__discount__button c-button c-button--default c-button--success c-button--shrinked">
                                View Deals
                            </button>
                        </div>
                    </base-transition-expand>
                    <div class="vc-cart__footer__buttons">
                        <button @click="hideCartPopup"
                                class="c-button c-button--default c-button--success">
                            Continue Shopping
                        </button>
                        <a :href="checkoutLink"
                           class="c-button c-button--default "
                           target="_top">
                            Checkout
                        </a>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>
<script>
    import Configure from '../../mixins/configure'
    import CartHeader from './cart-header.vue'
    import CartItemsList from './cart-items-list.vue'
    import CartItem from './cart-item.vue'
    import BaseDiscountIcon from '../base/icons/base-discount-icon.vue'
    import BaseTransitionExpand from "../base/base-transition-expand.vue";
    import GaLinkingParam from '../../../../shared/mixins/gaLinkingParam';

    export default {
        props: {
            mobile: {
                type: Boolean,
                default: false
            }
        },
        components: {
            BaseTransitionExpand,
            CartHeader, CartItemsList, CartItem, BaseDiscountIcon
        },
        mixins: [Configure, GaLinkingParam],
        computed: {
            cart() {
                return this.$store.state.cart;
            },
            config() {
                return this.$store.state.currentConfig;
            },
            cartEmpty() {
                return this.cart.getCart().length === 0;
            },
            checkoutLink() {
                let link = "/checkout";
                link += '?cart=' + this.cart.base64EncodedCart() + '&sales_tracking=' + (this.config.salesTracking ? this.config.salesTracking : '');

                if (this.$route.query.config_id !== undefined) {
                    link += '&config_id=' + this.$route.query.config_id;
                }

                if (this.gaLinkingParam) {
                    link += '&' + this.gaLinkingParam
                }

                return link;
            },
            showPackageDiscountsNotice() {
                return this.$store.state.showPackageDiscountsNotice;
            },
            lastItemInCart() {
                const cartItems = this.cart.cart;
                return cartItems[cartItems.length - 1];
            }
        },
        methods: {
            hideCartPopup() {
                if (this.$store.state.userClickedOnBuy) {
                    this.$store.commit('setUserClickedOnBuy', false);
                    return
                }

                this.$store.commit('toggleCartPopupClick', false);
            },
            showPackageDiscounts() {
                $("#discountsModal").modal('show');
            },
            keepCartPopupActive(val) {
                this.$store.commit('togglePopupIsHovered', val);
            }
        }
    }
</script>
